import { jsx as _jsx } from "react/jsx-runtime";
import { colors } from './details/detail.styles';
const truncatedUUID = (id) => `${id.substring(0, 8)}…`;
export const ResourceLink = ({ resourceType, resourceId, resourceName, locationId, onWorkOrderClick, onUserClick, onAccountClick, onLocationClick, onServiceClick, onInvoiceBatchClick, }) => {
    const label = resourceName && resourceName.trim() ? resourceName : truncatedUUID(resourceId);
    // Pick a handler based on resource type; when the host doesn't pass
    // the corresponding handler we render as plain text.
    let handler;
    switch (resourceType) {
        case 'work_order':
            // WO modal needs the location id to scope its sub-fetches; skip
            // navigation when absent rather than 4xx the modal open.
            if (onWorkOrderClick && locationId) {
                handler = () => onWorkOrderClick(resourceId, locationId);
            }
            break;
        case 'user':
            if (onUserClick)
                handler = () => onUserClick(resourceId);
            break;
        case 'account':
            if (onAccountClick)
                handler = () => onAccountClick(resourceId);
            break;
        case 'location':
            if (onLocationClick)
                handler = () => onLocationClick(resourceId);
            break;
        case 'service':
            if (onServiceClick)
                handler = () => onServiceClick(resourceId);
            break;
        case 'invoice_batch':
            if (onInvoiceBatchClick)
                handler = () => onInvoiceBatchClick(resourceId);
            break;
        default:
            handler = undefined;
    }
    if (!handler) {
        return (_jsx("span", { title: resourceId, style: { fontSize: 12, color: resourceName ? colors.text.primary : colors.text.secondary }, children: label }));
    }
    return (_jsx("button", { type: "button", onClick: (e) => {
            e.stopPropagation();
            handler();
        }, title: resourceId, style: {
            background: 'none',
            border: 'none',
            color: '#007AFF',
            cursor: 'pointer',
            padding: 0,
            fontSize: 12,
            textDecoration: 'underline',
            textAlign: 'left',
        }, children: label }));
};
export default ResourceLink;
